import script from "./expoundAnswerAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./expoundAnswerAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./expoundAnswerAddEditDialog.vue?vue&type=style&index=0&id=29a8a5a1&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a8a5a1"]])

export default __exports__